// NOTE: https://www.figma.com/file/PTejBF8pzgtVlgCpt0DeiZ/Speria?type=design&node-id=9-6247&mode=design&t=lnIeDN4Zln71pRTr-4
//       基本的には、Chakra UIのデフォルトカラーに従います。

export const tokens = {
  // https://www.tints.dev/primary/171923
  primary: {
    50: { value: "#E3E5ED" },
    100: { value: "#C8CBDB" },
    200: { value: "#9399B8" },
    300: { value: "#5F6791" },
    400: { value: "#3B4059" },
    500: { value: "#171923" },
    600: { value: "#12141C" },
    700: { value: "#0E0F16" },
    800: { value: "#0A0B0F" },
    900: { value: "#040406" },
  },
  blue: {
    50: { value: "#EBF8FF" },
    100: { value: "#BEE3F8" },
    200: { value: "#90CDF4" },
    300: { value: "#63B3ED" },
    400: { value: "#4299E1" },
    500: { value: "#3182CE" },
    600: { value: "#2B6CB0" },
    700: { value: "#2C5282" },
    800: { value: "#2A4365" },
    900: { value: "#1A365D" },
  },
  yellow: {
    50: { value: "#FFFFF0" },
    100: { value: "#FEFCBF" },
    200: { value: "#FAF089" },
    300: { value: "#F6E05E" },
    400: { value: "#ECC94B" },
    500: { value: "#D69E2E" },
    600: { value: "#B7791F" },
    700: { value: "#975A16" },
    800: { value: "#744210" },
    900: { value: "#5F370E" },
  },
  accent: {
    50: { value: "#F5F4F0" },
    100: { value: "#EDECE3" },
    200: { value: "#D9D6C4" },
    300: { value: "#C7C3A8" },
    400: { value: "#B3AE89" },
    500: { value: "#A19B6E" },
    600: { value: "#827D54" },
    700: { value: "#635F40" },
    800: { value: "#413E2A" },
    900: { value: "#222116" },
  },
  negative: {
    50: { value: "#FDEDED" },
    100: { value: "#FAD7D7" },
    200: { value: "#F5B3B3" },
    300: { value: "#EF8A8A" },
    400: { value: "#EA6666" },
    500: { value: "#E53E3E" },
    600: { value: "#CF1C1C" },
    700: { value: "#991515" },
    800: { value: "#670E0E" },
    900: { value: "#310707" },
  },
  ai: {
    50: { value: "#F3EFFB" },
    100: { value: "#E6DEF7" },
    200: { value: "#CDBEEE" },
    300: { value: "#B49DE6" },
    400: { value: "#9C7DDE" },
    500: { value: "#805AD5" },
    600: { value: "#6032C3" },
    700: { value: "#482592" },
    800: { value: "#301962" },
    900: { value: "#180C31" },
    950: { value: "#0C0618" },
  },
};

export const semanticTokens = {
  // colorPalette 用
  primary: {
    solid: { value: "{colors.primary.500}" },
    fg: { value: "{colors.primary.700}" },
    muted: { value: "{colors.primary.200}" },
    contrast: { value: "#FFF" },
    subtle: { value: "{colors.primary.50}" },
    focusRing: { value: "{colors.accent.400}" },
  },
  negative: {
    solid: { value: "{colors.negative.500}" },
    fg: { value: "{colors.negative.700}" },
    muted: { value: "{colors.negative.200}" },
    contrast: { value: "#FFF" },
    subtle: { value: "{colors.negative.50}" },
    focusRing: { value: "{colors.accent.400}" },
  },
  accent: {
    solid: { value: "{colors.accent.500}" },
    fg: { value: "{colors.accent.700}" },
    muted: { value: "{colors.accent.200}" },
    contrast: { value: "#FFF" },
    subtle: { value: "{colors.accent.50}" },
    focusRing: { value: "{colors.accent.400}" },
  },
  ai: {
    solid: { value: "{colors.ai.500}" },
    fg: { value: "{colors.ai.700}" },
    muted: { value: "{colors.ai.200}" },
    contrast: { value: "#FFF" },
    subtle: { value: "{colors.ai.50}" },
    focusRing: { value: "{colors.ai.400}" },
  },
  // semantic
  semantic: {
    core: {
      primary: { value: "#171923" },
      primaryInverted: { value: "#FFF" },
      accent: { value: "#A19B6E" },
      negative: { value: "#E53E3E" },
      warning: { value: "#D69E2E" },
      positive: { value: "#38A169" },
    },
    background: {
      primary: { value: "#FFF" },
      secondary: { value: "#F8F6F1" },
      tertiary: { value: "#FAFAFA" },
      inverted: { value: "#171923" },
      opaque: { value: "rgba(0, 0, 0, 0.36)" },
    },
    contents: {
      primary: { value: "#171923" },
      link: { value: "{colors.blue.600}" },
      secondary: { value: "#4A5568" },
      tertiary: { value: "#A0AEC0" },
      inverted: { value: "#FFF" },
      negative: { value: "#E53E3E" },
      warning: { value: "#B7791F" },
      positive: { value: "#38A169" },
      accent: { value: "#A19B6E" },
    },
    border: {
      selected: { value: "#171923" },
      opaque: { value: "#CBD5E0" },
      negative: { value: "#E53E3E" },
    },
  },
};
